// utils/message.js
import { Modal } from 'ant-design-vue'
import router from '@/router' // 导入 router 实例

export const successMessage = (msg, options = {}) => {
  if (document.getElementsByClassName('ant-message-notice-content').length === 0) {
    Modal.success({
      title: '成功',
      content: msg,
      okText: '确定',
      onOk: () => {
        if (options.route) {
          router.replace(options.route)
        }
      }
    })
  }
}

export const errorMessage = (msg, options = {}) => {
  if (document.getElementsByClassName('ant-modal-confirm-error').length === 0) {
    Modal.error({
      title: '提示',
      content: msg,
      okText: '确定',
      centered: true,
      width: 400,
      onOk: () => {
        if (options.route) {
          router.replace(options.route)
        }
      }
    })
  }
}
